export const ACTIVE_VERSION = 2;
export const AGENT_ID_PLACEHOLDER = '[agent-id]';

export enum SESSION_VIEW_TYPE {
  SESSIONS = 'SESSIONS',
  GROUP_BY_CONTACT = 'GROUP_BY_CONTACT',
  CONTACTS = 'CONTACTS',
}

export const DEFAULT_VIEW_SETTINGS = {
  tags: [],
  isEnabled: true,
  contacts: {},
  conversations: {
    tags: [],
    status: [],
    claimedBy: '',
    claimedByHistory: '',
    needsAction: false,
  },
  display: {
    type: SESSION_VIEW_TYPE.GROUP_BY_CONTACT,
  },
};
